import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// Apply theme before React mounts to prevent flash-of-wrong-theme
const stored = localStorage.getItem('cs-theme');
const initial =
  stored ?? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
document.documentElement.setAttribute('data-theme', initial);

// Apply density before React mounts
const storedDensity = localStorage.getItem('cs-density');
const initialDensity =
  storedDensity === 'compact' || storedDensity === 'comfortable' ? storedDensity : 'comfortable';
document.documentElement.setAttribute('data-density', initialDensity);

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
